import axios from 'axios';

import {
    FETCH_FEATURE_FLAG_SUCCESS,
    REDIRECT_TO_LOGIN,
    SWITCH_REPORT_TABS,
    SWITCH_SIDE_NAV_ITEMS
} from './types/ui-state-action-types';

import { find, get } from 'lodash';
import { sideNavItemsSelector } from '../selectors/ui-state-selectors';
import { userInfoSelector } from '../selectors/auth-selectors';
import {
    clearJwtCookie
} from '../../utils/cookie-utils';


export function redirectToLogout(){
    return ( dispatch, getState, { END_USER_AUTH_API, END_USER_APP_ID } ) => {
        clearJwtCookie();
        const state = getState();
        let url = `${END_USER_AUTH_API}/v1/token/logout?client_id=${END_USER_APP_ID}`;
        const email = userInfoSelector( state ).email;
        if( email ){
            url = url + `&user_email=${email}`;
        }
        window.location.replace( url );
        return {
            type: REDIRECT_TO_LOGIN
        };
    };
}

export function switchReportTabs( tabIndex, tabName ){
    return {
        selectedTabIndex: tabIndex,
        selectedTabName: tabName,
        type: SWITCH_REPORT_TABS,
    };
}

export function switchSideNavItems( id ){
    return ( dispatch, getState ) => {
        const state = getState();
        const navItems = sideNavItemsSelector( state );

        const selectedSideNavId = id;
        const selectedNavItem = find( navItems, ( item ) => item.id === selectedSideNavId );

        const name = get( selectedNavItem, 'label', 'Overview' );
        const url = get( selectedNavItem, 'url', '' );

        dispatch( {
            selectedItemId: id,
            selectedItemName: name,
            selectedItemUrl: url,
            type: SWITCH_SIDE_NAV_ITEMS,
        } );
    };
}

export function fetchFeatureFlags(){
    return ( dispatch, getState, { FEATURE_FLAG_API } ) => {

        return axios.get( FEATURE_FLAG_API ).then(
            ( response ) => {
                return dispatch( {
                    featureFlags: response.data.Item,
                    type: FETCH_FEATURE_FLAG_SUCCESS,
                } );
            } );
    };
}
